var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-terms text-remark" }, [
    _c("hr", { staticClass: "booking-divider" }),
    _vm._v(" "),
    _c("div", { attrs: { id: "accordion" } }, [
      _c("div", { staticClass: "card shadow-sm" }, [
        _c("div", { staticClass: "card-header", attrs: { id: "headingOne" } }, [
          _c("h5", { staticClass: "mb-0" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-link",
                attrs: {
                  "data-toggle": "collapse",
                  "data-target": "#collapseOne",
                  "aria-expanded": "true",
                  "aria-controls": "collapseOne"
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t(
                        "message.booking.payment_step.terms_and_conditions"
                      )
                    ) +
                    "\n          "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collapse show",
            attrs: {
              id: "collapseOne",
              "aria-labelledby": "headingOne",
              "data-parent": "#accordion"
            }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("ul", { staticClass: "maininfo-list" }, [
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "message.booking.checkout_step.terms_and_conditions01"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "message.booking.checkout_step.terms_and_conditions02"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _vm.preBookingData.service_id === 1
                  ? _c("li", [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "message.booking.checkout_step.terms_and_conditions03"
                            )
                          )
                        }
                      })
                    ])
                  : _vm._e()
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card shadow-sm" }, [
        _c("div", { staticClass: "card-header", attrs: { id: "headingTwo" } }, [
          _c("h5", { staticClass: "mb-0" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-link collapsed",
                attrs: {
                  "data-toggle": "collapse",
                  "data-target": "#collapseTwo",
                  "aria-expanded": "false",
                  "aria-controls": "collapseTwo"
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("message.booking.checkout_step.policy")) +
                    "\n          "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collapse",
            attrs: {
              id: "collapseTwo",
              "aria-labelledby": "headingTwo",
              "data-parent": "#accordion"
            }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("ul", { staticClass: "maininfo-list" }, [
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.booking.checkout_step.policy01"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.booking.checkout_step.policy02"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.booking.checkout_step.policy03"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.booking.checkout_step.policy04"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.booking.checkout_step.policy05"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.booking.checkout_step.policy06"))
                  )
                ])
              ])
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _vm.preBookingData.service_items
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body text-info" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("message.service_item.checkout_remark")) +
                "\n    "
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mt-3 custom-control custom-checkbox" }, [
      _c("input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required",
            expression: "'required'"
          }
        ],
        staticClass: "custom-control-input",
        attrs: {
          id: "acceptTerms",
          type: "checkbox",
          name: "acceptTerms",
          value: "true"
        },
        on: { change: _vm.acceptTC }
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "custom-control-label", attrs: { for: "acceptTerms" } },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("message.booking.checkout_step.accept_conditions01")
              ) +
              "\n      " +
              _vm._s(
                _vm.$t("message.booking.checkout_step.accept_conditions02")
              ) +
              "\n      " +
              _vm._s(
                _vm.$t("message.booking.checkout_step.accept_conditions03")
              ) +
              "\n      " +
              _vm._s(
                _vm.$t("message.booking.checkout_step.accept_conditions04")
              ) +
              "\n      "
          ),
          _c("a", { attrs: { href: "/term", target: "_blank" } }, [
            _c("u", [
              _vm._v(_vm._s(_vm.$t("message.booking.checkout_step.learn_more")))
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _vm.errors.has("acceptTerms")
      ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
          _c("i", { staticClass: "fas fa-exclamation-triangle" }),
          _vm._v(" " + _vm._s(_vm.$t("message.required_selection")) + "\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-abe1e3e8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abe1e3e8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/TermsConditions.vue
// module id = 1738
// module chunks = 0